const removeItemFromCart = async (arrayItems) => {
    const formData = { updates: {} };
    arrayItems.forEach((item) => {
        formData.updates[item.key] = 0;
    });
    const response = await fetch(
        window.Shopify.routes.root + "cart/update.js",
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
        }
    )
        .then((response) => {
            return response.json();
        })
        .catch((error) => {
            console.error("Error:", error);
        });
    return response ? true : false;
};
document.addEventListener("DOMContentLoaded", async () => {
    const checkBundlesPrices = async (cacheCart = null) => {
        const currentCurrency = Shopify.currency.active;
        const cart =
            cacheCart ?? (await fetch("/cart.js").then((res) => res.json()));
        const bundleInCart = cart.items.filter((item) => {
            const bundleComponents = JSON.parse(
                item.properties._quantitiesarray ?? null
            );
            if (
                bundleComponents &&
                bundleComponents.some(
                    (item) => item.price?.currencyCode !== currentCurrency
                )
            ) {
                return true;
            }
        });
        const item = bundleInCart[0];
        if (item) {
            const bundleComponents = JSON.parse(
                item.properties._quantitiesarray ?? null
            );
            if (
                bundleComponents &&
                bundleComponents.every((component) => component.price)
            ) {
                const currencyChanged = bundleComponents.some(
                    (component) =>
                        component.price?.currencyCode !== currentCurrency
                );
                if (currencyChanged) {
                    const newRawBundleComponentPromises =
                        await bundleComponents.map(async (component) => {
                            if (
                                component.price?.currencyCode !==
                                currentCurrency
                            ) {
                            }
                            const productData = await fetch(
                                `/products/${component.handle}.js`
                            ).then((res) => res.json());
                            const currentVariant = productData.variants.filter(
                                (variant) => variant.id == component.id
                            )[0];
                            component.price.amount = currentVariant.price / 100;
                            component.price.currencyCode = currentCurrency;
                            return component;
                        });
                    const newRawBundleComponent = await Promise.all(
                        newRawBundleComponentPromises
                    );
                    const rawPricesArray = newRawBundleComponent.map(
                        (component) => component.price.amount
                    );
                    const newbundleComponents = bundleComponents.map(
                        (component, index) => {
                            component.price.amount = rawPricesArray[index];
                            return component;
                        }
                    );
                    const formData = {
                        id: item.key,
                        properties: item.properties,
                    };
                    formData.properties["_quantitiesarray"] =
                        JSON.stringify(newbundleComponents);
                    const dataResponse = await fetch(
                        `${window.Shopify.routes.root}cart/change.js`,
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(formData),
                        }
                    ).then((res) => res.json());
                    const selectedItem = dataResponse.items.filter((item) => {
                        const bundleSetup = JSON.parse(
                            item.properties._quantitiesarray ?? null
                        );
                        if (bundleSetup) {
                            return newbundleComponents.every((value, index) => {
                                const targetValue = bundleSetup[index] ?? null;
                                return (
                                    targetValue.id === value.id &&
                                    targetValue.quantity === value.quantity
                                );
                            });
                        }
                    });
                    console.log("selectedItem", selectedItem);
                    await checkBundlesPrices(dataResponse);
                }
            }
        }
    };
    checkBundlesPrices();
    const cart = await fetch("/cart.js").then((res) => res.json());
    const uncompleteBundlesOrChildProducts = cart.items.filter(
        (item) =>
            item.properties._fatherbundleproduct ||
            item.properties._individualkey
    );
    if (uncompleteBundlesOrChildProducts.length) {
        const resonse = await removeItemFromCart(
            uncompleteBundlesOrChildProducts
        );
        if (resonse) {
            console.log("Deprecated bundle removed");
        }
    }
    checkBundleComponents();
});

const checkBundleComponents = async () => {
    const cart = await fetch("/cart.js").then((res) => res.json());
    const productDataArray = await Promise.all(
        await cart.items.map(
            async (item) =>
                await fetch(
                    `/products/${item.handle}?view=bundle-checker`
                ).then((res) => res.json())
        )
    );
    const itemsToRemove = cart.items.filter((item, index) => {
        const raw_components = JSON.parse(item.properties._quantitiesarray);
        const productData = productDataArray[index];
        if (productData.bundle_type === false) return false;
        if (raw_components) {
            let expectedQuantity = productData.quantity_items;
            const bundleComponents = productData.bundle_components;
            const ids = raw_components.map((component) => Number(component.id));
            const bundleQuantity = raw_components
                .map((component) => component.quantity)
                .reduce((a, b) => a + b, 0);
            if (productData.preselected_product) {
                expectedQuantity += 1;
                bundleComponents.push(productData.preselected_product);
            }
            const checkIds = ids.every((id) => bundleComponents.includes(id));
            if (!checkIds || expectedQuantity !== bundleQuantity) {
                console.log("Error bundle");
                return true;
            }
        } else {
            console.log("Error bundle");
            return true;
        }
    });
    if (itemsToRemove.length) {
        const resonse = await removeItemFromCart(itemsToRemove);
        if (resonse) {
            console.log("Error bundles removed");
            location.reload();
        }
    }
};
